import { PageContent } from '../../content/discover/content';
import HeaderNavigation from '../HeaderNavigation';

type DiscoverHeaderProps = {
  content: PageContent;
  /** When 'h2', the hero title uses h2 instead of h1 (so the page can reserve a single H1). */
  titleTag?: 'h1' | 'h2';
};

const DiscoverHeader = ({ content, titleTag = 'h1' }: DiscoverHeaderProps) => {
  const TitleTag = titleTag;
  return (
    <div className="relative bg-white">
      <div className="bg-white border-b border-gray-200">
        <HeaderNavigation />
      </div>
      <div
        className="bg-no-repeat bg-cover bg-center"
        style={content.hero.backgroundImage ? { backgroundImage: `url(${content.hero.backgroundImage})` } : undefined}
      >
        {content.hero.variant === 'centeredImage' ? (
          <div className="container mx-auto px-4 md:px-8 py-16 w-full max-w-[1280px]">
            <div className="flex justify-center items-center h-[320px] md:h-[420px] lg:h-[480px]">
              <img
                src={content.hero.heroImage}
                alt="Tokyo food experiences"
                className="max-h-full w-auto max-w-full object-contain"
              />
            </div>
          </div>
        ) : (
          <div className="container mx-auto px-4 md:px-8 py-16 w-full max-w-[1280px]">
            <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
              <div className="space-y-6">
                {content.hero.overlayLogo ? (
                  <img
                    src={content.hero.overlayLogo}
                    alt=""
                    aria-hidden
                    className="w-40 md:w-48"
                  />
                ) : null}
                <TitleTag className="text-4xl md:text-6xl font-semibold mb-4 text-gray-900 leading-[44px] md:leading-[72px] tracking-[-0.72px] md:tracking-[-1.2px] ">
                  {content.hero.headline ? (
                    content.hero.headlineHighlight ? (
                      <>
                        {content.hero.headline.replace(content.hero.headlineHighlight, '')}
                        <span className="bg-gradient-to-r from-[#444CE7] to-[#E3B4FF] bg-clip-text text-transparent">
                          {content.hero.headlineHighlight}
                        </span>
                      </>
                    ) : (
                      <span className="bg-gradient-to-r from-[#444CE7] to-[#E3B4FF] bg-clip-text text-transparent">
                        {content.hero.headline}
                      </span>
                    )
                  ) : (
                    <>
                      Upcoming{' '}
                      <span className="bg-gradient-to-r from-[#444CE7] to-[#E3B4FF] bg-clip-text text-transparent">
                        {content.hero.title?.highlight}
                      </span>
                      {' '}in {content.hero.city}
                    </>
                  )}
                </TitleTag>
                <p className="text-xl text-gray-600 leading-relaxed">
                  {content.hero.description}
                </p>
              </div>
              <div className="relative">
                <img
                  src={content.hero.heroImage}
                  alt={content.hero.title?.highlight}
                  className="w-full h-[280px] md:w-[576px] md:h-[480px] rounded-lg shadow-lg object-cover object-center"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DiscoverHeader; 